import AuthForm from '../components/form/AuthForm.jsx';

const SignUpPage = () => {
  return (
    <>
      <AuthForm />
    </>
  );
};

export default SignUpPage;
